import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import settings from './config'
import VueScrollTo from 'vue-scrollto' // var VueScrollTo = require('vue-scrollto');
 
Vue.use(VueScrollTo)

if (!window.moment) { console.log('!!moment not defined!') }
window.moment.tz.add(settings.DATETIME.MOMENT_TIME_ZONE)
window.moment.tz.setDefault(settings.DATETIME.TIME_ZONE)

Vue.use(VueGoogleMaps, {
  load: {
    key      : settings.MAP.API_KEY,
    // key      : 'AIzaSyDKPPpl8nJqJMeHCF9MQKqXCsKBwynQkFM',    
    v        : '3',
    libraries: 'places,geometry' // If you need to use place input
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#vue-app')



// WEBPACK FOOTER //
// ./src/main.js